export const MixedAirlineKey = "Mixed Airline";

export const AircraftUnknown = "Unknown";

export const UnknownAirlineKey = "Unknown";

export const MaxPointsSliderSort = ["Economy", "PremiumEconomy", "First", "Business"];

export const CabinsMap = new Map([
  ["Economy", "Economy"],
  ["PremiumEconomy", "Premium Economy"],
  ["Business", "Business"],
  ["First", "First"],
]);

export const FieldToCabins: Record<string, string> = {
  y: "Economy",
  w: "PremiumEconomy",
  f: "First",
  j: "Business",
};
